import styled from 'styled-components';

const StyledContainer = styled.div`
	position: fixed;
	top: 80px;
	right: 80px;
	z-index: 4;
	width: 40px;
	height: 40px;
	background: #111314;
	border: 1px solid rgba(255, 255, 255, 0.1);
	border-radius: 10px;
	display: flex;
	align-items: center;
	justify-content: center;
	cursor: pointer;
	transition: background-color 0.3s ease;

	.img-icon {
		background-color: #ffffff;
		transition: background-color 0.3s ease;
	}

	&:hover {
		background-color: #ffffff;

		.img-icon {
			background-color: #000000;
		}
	}
`;

export { StyledContainer };
